import styled from 'styled-components';

export const SignupWrapper = styled.div`
 min-height: 100vh;
 display: flex;

    .ant-input {
        background-color: #ffffff !important;
        border-color: #d9d9d9 !important;
        color: #000000d9 !important;
    }
    .ant-input-affix-wrapper:hover {
        border-color: #40a9ff !important;
    }
    .ant-input-affix-wrapper:focus {
        border-color: #40a9ff !important;
    }
    .ant-input-affix-wrapper {
      border-radius: 8px;
    }
    .ant-input-group-addon {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }
    .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) 
    .ant-select-selector {
      border: none !important;
      box-shadow: none !important;
    }
    .ant-input-group-addon .ant-select-focused .ant-select-selector {
      color: var(--primary-text-color) !important;
    }

    /* reCAPTCHA styling */
    .recaptcha-badge {
      font-size: 12px;
      color: #666;
      display: flex;
      align-items: center;
      gap: 8px;
      justify-content: center;
      margin-top: 16px;
    }

    .recaptcha-badge-icon {
      width: 16px;
      height: 16px;
      background: #f0f0f0;
      border-radius: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 10px;
      color: #666;
    }
    .customZipSpin {
      position: absolute;
      z-index: 1;
      top: 14px;
      right: 10px
    }
`;